module.exports = __webpack_public_path__ + "static/media/image_64.1aae70f2.png";